import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBenefitCardIconVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 32,
	viewBox: "0 0 38 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.4622 2.61115C20.8545 2.30544 21.3593 2.16633 22.0482 2.35292L34.2891 6.77032C35.8343 7.29011 36.579 8.31803 36.1051 9.69831L29.6635 27.4837C29.3319 28.4641 28.5231 29.557 27.3061 29.1847L21.2585 27.173",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.60777 5.84474L16.0066 1.36479C17.3621 0.903952 18.7857 0.514199 19.6558 2.59867L26.7585 22.303C27.6975 24.4552 26.5316 25.575 25.1304 26.0089L12.1985 30.6866C9.70098 31.3176 8.92756 31.0112 7.86556 27.988L6.38117 23.7784M6.40087 23.8493L1.32654 9.55795C0.337298 7.06648 1.73009 6.46501 3.65614 5.83161",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1996 14.1143C17.1305 14.2986 17.5469 15.4427 16.9523 16.1822L14.242 19.5531C13.6428 20.2984 12.468 20.0741 12.1318 19.1503L10.5991 14.9392C10.2628 14.0154 11.0186 13.0885 11.9567 13.2742L16.1996 14.1143Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinejoin: "round"
		})
	]
});
export default SvgBenefitCardIconVideo;
